<template>
  <InPlayerVideoOverlay>
    <OverlayContent
      :icon="icon"
      :icon-alignment="iconAlignment"
    >
      <template
        v-if="shouldRender('title')"
        slot="title"
      >
        <span :class="$style.multiLine">{{ $t('title') }}</span>
      </template>

      <template
        v-if="shouldRender('message')"
        slot="message"
      >
        <span :class="$style.multiLine">{{ $t('message') }}</span>
      </template>

      <ActionDescriptorsRenderer
        slot="content"
        :translator="translator"
        :descriptors="overlay.presentation && overlay.presentation.descriptor && overlay.presentation.descriptor.action"
        @action-click="handleActionClick"
      />
    </OverlayContent>

    <FooterAction
      v-if="isDismissable && shouldRender('dismiss')"
      slot="footer"
      @click="() => dismiss({ autoplay: true })"
    >
      {{ $t('dismiss') }}
    </FooterAction>
  </InPlayerVideoOverlay>
</template>

<script lang="ts">
import BranchLinkButton from '@/scripts/Components/Utilities/BranchLinkButton';
import { VideoOverlayType } from '@/scripts/store/modules/video/state/VideoOverlay';
import { VideoPlayerOverlayBase } from '../layout/VideoPlayerOverlayBase';
import InPlayerVideoOverlay from '../layout/InPlayerVideoOverlay.vue';
import OverlayContent from '../components/OverlayContent.ts.vue';
import OverlayButton from '../components/OverlayButton.ts.vue';
import FooterAction from '../components/FooterAction.ts.vue';
import { ActionDescriptorsRenderer } from './CommonPresentationOverlay/ActionDescriptorsRenderer';
import { getAction } from './CommonPresentationOverlay/handleActionClick';
import { ActionContext, ActionDescriptor } from '../../controllers/VideoOverlayPresentation';

export default VideoPlayerOverlayBase.extend({
  components: {
    BranchLinkButton,
    InPlayerVideoOverlay,
    OverlayContent,
    OverlayButton,
    FooterAction,

    ActionDescriptorsRenderer,
  },

  computed: {
    isDismissable(): boolean {
      return this.overlay.type === VideoOverlayType.Dismissable;
    },

    icon(): string | undefined {
      return this.overlay.presentation?.descriptor?.title?.icon?.name ?? undefined;
    },
    iconAlignment(): string | undefined {
      return this.overlay.presentation?.descriptor?.title?.icon?.align ?? undefined;
    },
  },

  methods: {
    shouldRender(value: string): boolean {
      return !!(this.$t(value, { defaultValue: '' }));
    },

    translator(...args: any[]): string {
      return this.$t(...args);
    },

    handleActionClick(actionDescriptor: ActionDescriptor, event: Event): void {
      const { action, tracker } = actionDescriptor;

      const actionContext: ActionContext = {
        el: event.target as HTMLElement | null,
        video: this.video,
        overlay: this.overlay,
      };

      const actionFn = getAction(action, actionContext);

      this.performAction({
        fn: actionFn ?? undefined,
        tracker: tracker as any,
      });
    },
  },
});
</script>

<style lang="scss" module>
.multiLine {
  white-space: pre-line;
}
</style>
